import {en_US} from "./en_US";
export const en = en_US;


// WEBPACK FOOTER //
// ./~/report-components/src/components/date.i18n/en.js